import React from 'react';
import VCardResume from './VCardResume';
import VCardActions from './VCardActions';
import PropTypes from 'prop-types';
import { VCARD_DETAILS_MAIN_CLASSNAME, VCARD_SEASON_BUY_CLASSNAME} from '../Constants';
import { cls } from '../../../packages/components';
import Translator from "../../../../src/requests/apa/Translator";
import DeviceStorage  from '../../../components/DeviceStorage/DeviceStorage';

const VCardDetails = ({ data, buttons, addonDescription, isLoading, dataEpisodes, notification }) => {
    const {
        title = '',
        episode = null,
        subtitle = '',
        genders = [],
        year = '',
        parentalRating = '',
        duration = '',
        synopsis = '',
        image = '',
        isSerie = false,
        progress = 0
    } = data || {};
    const region = DeviceStorage.getItem('region');
    const btn = buttons;
    const btnTransactional = Object.values(btn);
    const btnTransactionalTitles =  btnTransactional.filter(b => typeof b.text === 'string' ? b.text.includes('Temporada') || b.text.includes('Episodio'): '');
    return (
        <div className={cls(VCARD_DETAILS_MAIN_CLASSNAME)} style={{backgroundImage: `url('${image}')`}}>
            <div className="gradient">
                <div className="gradientTop">
                    <VCardResume 
                        isLoading={isLoading}
                        title={title}
                        subtitle={subtitle}
                        genders={genders}
                        year={year}
                        parentalRating={parentalRating}
                        duration={duration}
                        synopsis={synopsis}
                        isSerie={isSerie}
                        progress={progress}
                        addonDescription={addonDescription}
                        episode={episode}
                        dataEpisodes={dataEpisodes}
                        notification={notification}
                    />
                    <VCardActions buttons={buttons} isLoading={isLoading}/>
                </div>
                {!isLoading  && isSerie && btnTransactionalTitles.length > 0 && <div className={cls(VCARD_SEASON_BUY_CLASSNAME)}>{Translator.get(`cv_episodebuy_download_buy_${region}_wp0_disclaimer`,'')}</div>}
            </div>
        </div>
    )
}

VCardDetails.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        episode: PropTypes.oneOf(null, PropTypes.object),
        genders: PropTypes.arrayOf(PropTypes.string).isRequired,
        year: PropTypes.string.isRequired,
        parentalRating: PropTypes.string.isRequired,
        duration: PropTypes.string.isRequired,
        synopsis: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        isSerie: PropTypes.bool.isRequired,
        progress: PropTypes.number,
    }).isRequired,
    buttons: PropTypes.array,
    addonDescription: PropTypes.node,
    isLoading: PropTypes.bool,
    notification: PropTypes.element,
}

VCardDetails.defaultProps = {
    data: {},
    buttons: [],
    addonDescription: null,
    isLoading: false,
    notification: null
}

export default VCardDetails;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardDetails.jsx